import { ReactNode } from "react";
import Answered from "@/components/Answered";
import ChatBubble from "@/components/ChatBubble";
import Page from "@/components/Page";
import styles from "@/pages/Pages.module.scss";

type Props = {
  children?: ReactNode;
  variant?: "A" | "B";
};

export default function HypertensionRecommendationContent({ children }: Props) {
  const exstingDiagnosisQuestionId = "q1";

  const infoSection = (
    <>
      <Answered affirmative to={exstingDiagnosisQuestionId}>
        <p>
          Tack för ditt svar! Nu behöver du bara logga in med BankID för att
          komma igång.
        </p>
      </Answered>

      <Answered negative to={exstingDiagnosisQuestionId}>
        <p>
          Tack för dina svar! Nu behöver du bara logga in med BankID för att
          komma igång.
        </p>
      </Answered>

      <p>
        Friska är en registrerad svensk vårdgivare. BankID krävs för
        trygg och säker identifiering.
      </p>
    </>
  );

  return (
    <Page>
      <div className="mb-30">
        <ChatBubble>
          Visste du att ca 2,3 miljoner svenskar har högt blodtryck och hälften
          vet inte om det?
        </ChatBubble>
      </div>

      <Answered affirmative to={exstingDiagnosisQuestionId}>
        <h1>Kom igång med behandling för högt blodtryck</h1>

        <section>{infoSection}</section>
      </Answered>

      <Answered negative to={exstingDiagnosisQuestionId}>
        <h1>Kom igång med utredning för högt blodtryck</h1>

        <section>{infoSection}</section>
      </Answered>

      <p className={styles.noCommitment}>
        Ingen bindningstid — avsluta när som helst
      </p>

      {children}

      <div className={styles.additionalInfo}>
        <strong>Tänk på att</strong>
        <ul>
          <li>
            Behandling eller utredning för högt blodtryck är idag inte utformad
            för att hjälpa personer med hjärt-njursvikt eller under tiden som du
            är gravid.
          </li>
        </ul>
      </div>
    </Page>
  );
}
